<script>
import Histories from '@/views/Application/Sales/Accounts/Account/Histories'

export default {
  extends: Histories,
  data () {
    return {
      title: 'Histories',
      breadcrumb: {
        name: 'Histories',
        route: { name: 'customerservice-accounts-account-histories', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
